import { Container, Content } from "./styles";

import Close from "../../../assets/images/icons/close.svg";

const SideBar = ({ active }) => {
  const closeSideBar = () => {
    if (active) {
      active(false);
    }
  };

  const handleNavLink = (id) => {
    const target = document.querySelector(`#${id}`);

    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }

    closeSideBar();
  };

  return (
    <Container $sidebar={active ? "true" : "false"}>
      {active && <img src={Close} alt="icone" onClick={closeSideBar} />}
      <Content>
        <nav>
          <ul>
            <li onClick={() => handleNavLink("aboutUs")}>Quem Somos</li>
            <li onClick={() => handleNavLink("realmadrid")}>
              Arena Ibirapuera
            </li>
            <li onClick={() => handleNavLink("academy")}>ESP Academy</li>
            <li onClick={() => handleNavLink("esp")}>ESP Experience</li>
            <li onClick={() => handleNavLink("social")}>ESP Social</li>
            <li onClick={() => handleNavLink("realmadrid")}>
              Fundação Real Madrid
            </li>
            <li onClick={() => handleNavLink("form")}>Contato</li>
          </ul>
        </nav>
      </Content>
    </Container>
  );
};

export default SideBar;
